import { TechRadarApi } from '@backstage-community/plugin-tech-radar';

import radarData from '../techradar.json';

export class MyOwnClient implements TechRadarApi {
  async load(): Promise<any> {
    const _data = radarData;

    return {
      quadrants: [
        {
          name: 'Programming languages and frameworks',
          id: '0',
        },
        {
          name: 'Platforms & Infrastructure',
          id: '1',
        },
        {
          name: 'Application development techniques/tools',
          id: '2',
        },
        {
          name: 'Data & data management',
          id: '3',
        },
      ],
      rings: [
        {
          name: 'PROMOTE',
          color: '#93c47d',
          id: '0',
        },
        {
          name: 'TRIAL',
          color: '#8983ca',
          id: '1',
        },
        {
          name: 'ASSESS',
          color: '#fce8b2',
          id: '2',
        },
        {
          name: 'HOLD',
          color: '#cc9e9e',
          id: '3',
        },
      ],
      entries: _data
        .sort((a, b) => parseInt(a.id) - parseInt(b.id))
        .map(item => ({
          id: item.index,
          title: item.label,
          description: item.description +"  "+ "\nSPOC:" + item.spoc,
          key: item.index,
          quadrant: item.quadrant.toString(),
          timeline: [
            {
              moved: item.moved,
              ringId: item.ring.toString(),
              date: new Date(item.date),
              description: "",
            },
          ],
          index: item.index,
        })),
    };
  }
}
